import { Pipe, PipeTransform } from '@angular/core'
import moment from 'moment'

@Pipe({
  name: 'dob',
  pure: false,
  standalone: false,
})
export class DateOfBirthPipe implements PipeTransform {
  transform(dob?: Date | moment.Moment | string) {
    if (dob != null) {
      return moment(dob).format('MM/DD/YYYY')
    } else {
      return ''
    }
  }
}
